const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ROLES = ["TM1", "TM2", "TM3", "TM4", "TM5", "TM6"];
const CORE_TEAM = ["Alex", "Andy", "Ellis", "Lily", "Amie", "Shannon"];

// Check if a job is from the Essex Photo Studio calendar
const isStudioJob = (job) => job.source === "essex_studio" || job.source === "google_studio";

// Check if a job is a wedding fair (exhibition stand, not a couple's wedding)
const isWeddingFair = (job) => {
  const name = (job.event_name || job.title || '').toLowerCase();
  return name.includes('wedding fair');
};

// Check if a job is a wedding (eligible for job sheets)
const isWeddingJob = (job) => {
  const name = (job.event_name || job.title || '').toLowerCase();
  if (job.is_unavailable) return false;
  if (isStudioJob(job)) return false;
  if (name.includes('open day') || name.includes('show') || name.includes('work experience') || name.includes('wedding fair') || name.includes('conference') || name.includes('awards')) return false;
  return name.includes('wedding') || name.includes('highlight video') || name.includes('highlight film') || name.includes('photos & video') || name.includes('photo & video') || name.includes('vow renewal') || name.includes('vowel renewal');
};

const isGuestbookJob = (job) => {
  if (isStudioJob(job)) return false;
  const name = (job.event_name || job.title || '').toLowerCase();
  return name.includes('video messages guestbook');
};

const hasJobSheet = (job) => isWeddingJob(job) || isGuestbookJob(job);

// Minimum staffing rules based on event type
const getMinStaff = (eventName) => {
  if (!eventName) return 0;
  const name = eventName.toUpperCase();
  if (name.includes('WEDDING FAIR'))
    return 1;
  if (name.includes('WORK EXPERIENCE'))
    return 2;
  if (name.includes('PROPERTY'))
    return 1;
  if (name.includes('PHOTO') && name.includes('HIGHLIGHT'))
    return 2;
  if ((name.includes('VIDEO') || name.includes('FILM')) && name.includes('PHOTO'))
    return 3;
  if (name.includes('WEDDING') && (name.includes('FILM') || name.includes('VIDEO')))
    return 2;
  if (name.includes('WEDDING') && name.includes('PHOTO'))
    return 1;
  if (name.includes('DANCE SHOW'))
    return 2;
  return 0;
};

// Event type classification (same logic as staffing)
const getEventType = (eventName) => {
  if (!eventName) return "other";
  const name = eventName.toUpperCase();
  if (name.includes('WEDDING FAIR'))
    return "fair";
  const isWedding = name.includes('WEDDING');
  if (isWedding && (name.includes('VIDEO') || name.includes('FILM')) && name.includes('PHOTO') && !name.includes('HIGHLIGHT'))
    return "video-photo";
  if (isWedding && name.includes('PHOTO') && name.includes('HIGHLIGHT'))
    return "photo-highlight";
  if (isWedding && (name.includes('FILM') || name.includes('VIDEO')) && !name.includes('PHOTO'))
    return "video";
  if (isWedding && name.includes('PHOTO'))
    return "photo";
  if (name.includes('DANCE SHOW'))
    return "dance";
  return "other";
};

const EVENT_TYPE_LABELS = {
  "all": "All Types",
  "wedding": "All Weddings",
  "video": "Wedding Video",
  "video-photo": "Wedding Photo & Video",
  "photo-highlight": "Photo & Highlight Video",
  "photo": "Wedding Photos",
  "fair": "Wedding Fair",
  "dance": "Dance Show",
  "other": "Other",
};

// Get today's date in YYYY-MM-DD format (always BST/Europe London)
const getTodayDate = () => {
  return new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/London' });
};

// Days from today until a YYYY-MM-DD date (null if no date)
const daysUntilJob = (dateStr) => {
  if (!dateStr) return null;
  return Math.round((new Date(dateStr) - new Date(getTodayDate())) / 86400000);
};

// Pending sheet is overdue when the wedding is under 2 weeks away
const isSheetOverdue = (dateStr) => {
  const days = daysUntilJob(dateStr);
  return days !== null && days >= 0 && days < 14;
};

// Extract venue from location string (remove address details)
const extractVenue = (location) => {
  if (!location) return null;
  const parts = location.split(/\s+(?=\d|[A-Z]{1,2}\d)/);
  return parts[0]?.trim() || location;
};

export {
  BACKEND_URL,
  API,
  ROLES,
  CORE_TEAM,
  isStudioJob,
  isWeddingJob,
  isWeddingFair,
  isGuestbookJob,
  hasJobSheet,
  getMinStaff,
  getEventType,
  EVENT_TYPE_LABELS,
  getTodayDate,
  daysUntilJob,
  isSheetOverdue,
  extractVenue,
};
